import React from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { FaFileUpload } from 'react-icons/fa';

export interface DragDropProps {
  callback: () => Promise<void>;
  handleChange: (fileList: FileList) => void;
  fileTypes: string[];
}

const DragDrop = ({
  callback,
  handleChange,
  fileTypes,
}: DragDropProps): JSX.Element => {
  return (
    <div>
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        multiple
        hoverTitle="solte aqui"
      >
        <div className="flex h-[64px] cursor-pointer flex-row items-center gap-4 rounded border-2 border-dashed border-foreground-500 px-4">
          <FaFileUpload className="h-6 w-6 text-foreground-700" />

          <p className="text-sm text-foreground-700">
            Clique ou solte aqui os arquivos NOTFIS da FAST para importar
          </p>
        </div>
      </FileUploader>
    </div>
  );
};

export default DragDrop;
